import React, { useContext } from 'react';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import deDe from 'antd/lib/locale/de_DE';
import enUS from 'antd/lib/locale/en_US';
import GlobalStyle from './styles/GlobalStyle';
import 'typeface-montserrat';
import 'typeface-lato';
import { AppRouter } from './components/router/AppRouter';
import { useLanguage } from './hooks/useLanguage';
import { useAutoNightMode } from './hooks/useAutoNightMode';
import { usePWA } from './hooks/usePWA';
import { useThemeWatcher } from './hooks/useThemeWatcher';
import { useAppSelector } from './hooks/reduxHooks';
import { themeObject } from './styles/themes/themeVariables';
import { BreadcrumbProvider } from './components/header/components/Breadcrumb/BreadcrumbContext';
import { VariantContext } from './variant';
import { useRoutesByVariant } from './hooks/useRoutesByVariant';
import "./styles/overrides.css";  // 👈 add here
const App: React.FC = () => {
  const { id } = useContext(VariantContext); // 'control' | 'user'
  const routes = useRoutesByVariant(id);

  const { language } = useLanguage();
  const theme = useAppSelector((s) => s.theme.theme);

  usePWA();
  useAutoNightMode();
  useThemeWatcher();

  if (!routes) return <div style={{ padding: 16 }}>Loading…</div>;

  return (
    <>

      <meta name="theme-color" content={themeObject[theme].primary} />
      <GlobalStyle />
      <HelmetProvider>
        <BreadcrumbProvider>
          <ConfigProvider locale={language === 'en' ? enUS : deDe}>
            <AppRouter routes={routes} />
          </ConfigProvider>
        </BreadcrumbProvider>
      </HelmetProvider>
    </>
  );
};

export default App;
